import { FC, useCallback, useEffect, useState } from "react";

import { DigipostEntryPoint } from "../../../types/entrypoint";
import { useEntrypointContext } from "../EntrypointContext";
import {
  getTokenApproveCode,
  getTokenObjectFromBackend,
  useTokenParam,
} from "./oauth-utils";
import SpinnerContainer from "./spinnerContainer/SpinnerContainer";

export const OAuthSuccess: FC = () => {
  const entrypoint: DigipostEntryPoint = useEntrypointContext();
  const [asyncError, setAsyncError] = useState<Error>();

  const token = useTokenParam();

  if (asyncError) {
    throw asyncError;
  }

  const authorizeTokenAndRedirectToApp =
    useCallback(async (): Promise<void> => {
      try {
        const tokenObject = await getTokenObjectFromBackend(token);
        const approveCode = await getTokenApproveCode(
          tokenObject,
          entrypoint.csrfToken,
        );
        window.location.href = `${tokenObject.redirectUri}?&state=${tokenObject.state}&code=${approveCode}`;
      } catch (error) {
        if (typeof error === "string") {
          setAsyncError(new Error(error));
        } else if (error instanceof Error) {
          setAsyncError(error);
        } else {
          setAsyncError(
            new Error("Unknown error occurred during token approve"),
          );
        }
      }
    }, [entrypoint, token]);

  useEffect(() => {
    authorizeTokenAndRedirectToApp();
  }, [authorizeTokenAndRedirectToApp]);

  return <SpinnerContainer />;
};
